<ng-container *transloco="let t">
  <ld-base-modal [title]="title() || t('maintenanceTitle')" [showCloseButton]="false" [closeOnBackdropClick]="false">
    <div modal-content>
      <div id="maintenance-modal-icon" class="pt-8 pb-4 flex justify-center">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="w-10 h-10 text-amber-500"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          stroke-width="2"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
          />
        </svg>
      </div>

      <div id="maintenance-modal-body" class="px-6 pb-8 text-center">
        <p id="maintenance-modal-message" class="text-ld-neutral-600">
          {{ t(message()) || t('maintenanceMessage') }}
        </p>
      </div>
    </div>
  </ld-base-modal>
</ng-container>
